import React from "react";
import { Link } from "react-router-dom";

const StateList = () => {
  // Dummy data for states
  const states = [
    {
      id: 1,
      state: "Maharashtra",
      country: "India",
      status: "Active",
    },
    {
      id: 2,
      state: "California",
      country: "USA",
      status: "Inactive",
    },
    {
      id: 3,
      state: "Ontario",
      country: "Canada",
      status: "Active",
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">State Master</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">State Master</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Add Button */}
        <div className="row mb-3">
          <div className="col-12 text-end">
            <Link to="/state-add" className="btn btn-primary">
              + Add State
            </Link>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>State Name</th>
                        <th>Country</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {states.map((state, index) => (
                        <tr key={state.id}>
                          <td>{index + 1}</td>
                          <td>{state.state}</td>
                          <td>{state.country}</td>
                          <td>
                            <span
                              className={`badge ${
                                state.status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {state.status}
                            </span>
                          </td>
                          <td>
                            <div className="d-flex gap-2">
                              <a href="#!" className="btn btn-light btn-sm">
                                <i className="fa-solid fa-eye fs-16"></i>
                              </a>
                              <a
                                href="#!"
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </a>
                              <a
                                href="#!"
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {states.length === 0 && (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

export default StateList;
